import { ExternalLink } from 'lucide-react'
import { Card, CardHeader, CardTitle } from '@/shared/components/ui/card'
import type { BusinessDetail } from '../../hooks/useBusiness'

interface BusinessOverviewCardProps {
  business: BusinessDetail
}

function Field({ label, value }: { label: string; value: React.ReactNode }) {
  return (
    <div className="flex flex-col gap-1">
      <span className="text-xs uppercase tracking-wide text-ink-subtle">{label}</span>
      <span className="text-sm font-medium text-ink">{value || '—'}</span>
    </div>
  )
}

export function BusinessOverviewCard({ business }: BusinessOverviewCardProps) {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Información del negocio</CardTitle>
      </CardHeader>
      <div className="grid gap-5 sm:grid-cols-2">
        <Field label="Nombre legal" value={business.legalName} />
        <Field label="DNI / RUT" value={business.dni} />
        <Field label="Slug" value={business.slug} />
        <Field
          label="Tienda online"
          value={
            business.storeUrl ? (
              <a
                href={business.storeUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-1 text-accent-dark hover:underline"
              >
                {business.storeUrl}
                <ExternalLink className="h-3 w-3" />
              </a>
            ) : (
              ''
            )
          }
        />
        <div className="sm:col-span-2">
          <Field label="Descripción" value={business.description} />
        </div>
      </div>
    </Card>
  )
}
